import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './output.css';
import Login from './Pages/Login/index';
import Dashboard from './Pages/Dashboard/index';
import Admin from './Pages/admin/admin';
import Show from './Pages/Editors/ShowsEditor';
import NotFound from './Components/404';
import ViewShortPost from './Pages/View Show Post';
import Ticket from './Pages/Editors/TicketEditor';
import Register from './Pages/Register';
import UpdateShow from './Pages/Editors/ShowsEditor/updateShow';
import ViewLongPost from './Pages/View Tickets Post';
import UpdateTicket from './Pages/Editors/TicketEditor/updateTicket';
import ChangePassword from './Pages/admin/changepw';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import TicketPrices from './Pages/Editors/TicketPricesEditor';
import UpdateCommunity from './Pages/Editors/TicketPricesEditor/updateTicketPrices';
import ViewCommunityPost from './Pages/View Ticket Prices Post';
import Video from './Pages/Editors/VideosEditor';
import UpdateVideo from './Pages/Editors/VideosEditor/updateVideo'
import ViewVideoPost from './Pages/View Video Post';
import Sidebar from './Components/base/sidebar';
import ViewBuyLinkPost from './Pages/View Buy Link Post';
import BuyLink from './Pages/Editors/BuyLinksEditor';
import UpdateBuyLink from './Pages/Editors/BuyLinksEditor/updateBuyLinks';
import ViewGalleryPost from './Pages/View Gallery';
import UpdateGallery from './Pages/Editors/GalleryEditor/updateGallery';
import Gallery from './Pages/Editors/GalleryEditor';
import ViewSeatPlan from './Pages/View Seat Plan';
import SeatPlan from './Pages/Editors/SeatPlanEditor';

// Private Layout (with Sidebar, etc.)
function PrivateLayout() {
  return (
    <div className='flex font-graphik'>
      <Sidebar />
      <main className="container flex justify-center bg-gray-100 h-[100vh] overflow-auto">
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/show" element={<Show />} />
          <Route path="/view/post/Show" element={<ViewShortPost />} />
          <Route path="/update/show" element={<UpdateShow />} />
          <Route path="/ticket-prices" element={<TicketPrices />} />
          <Route path="/update/ticket-prices" element={<UpdateCommunity />} />
          <Route path="/view/post/ticket-prices" element={<ViewCommunityPost />} />
          <Route path="/ticket" element={<Ticket />} />
          <Route path="/view/post/ticket" element={<ViewLongPost />} />
          <Route path="/update/ticket" element={<UpdateTicket />} />
          <Route path="/video" element={<Video />} />
          <Route path="/view/post/video" element={<ViewVideoPost />} />
          <Route path="/update/video" element={<UpdateVideo />} />
          <Route path="/view/post/buy-links" element={<ViewBuyLinkPost/>} />
          <Route path="/buy-link" element={<BuyLink />} />
          <Route path="/update/buy-links" element={<UpdateBuyLink />} />
          <Route path="/update/gallery" element={<UpdateGallery/>} />
          <Route path="/gallery" element={<Gallery/>} />
          <Route path="/view/post/gallery" element={<ViewGalleryPost/>}/>
          <Route path="seatPlan" element={<SeatPlan/>} />
          <Route path="/view/post/seatPlan" element={<ViewSeatPlan/>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </div>
  );
}

// Public Layout (for Login, Register, etc.)
function PublicLayout() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default function App() {

  return (
    <Router>
      <ReactTooltip id="edit" place="right" content="Edit" />
      <ReactTooltip id="preview" place="right" content="Preview" />
      <ReactTooltip id="delete" place="right" content="Delete" />
      <ReactTooltip id="feature" place="right" content="Feature Coming Soon" />

      {/* Conditionally render layout based on the current route */}
      <Routes>
        <Route path="/login" element={<PublicLayout />} />
        <Route path="/" element={<PublicLayout />} />
        <Route path="/register" element={<Register />} />
        
        {/* For all other routes, render the Private Layout */}
        <Route path="*" element={<PrivateLayout />} />
      </Routes>
    </Router>
  );
}
